// extracted by mini-css-extract-plugin
export var childrenContainer = "_d8-0";
export var virtualScrollArea = "_d8-1";